export const gothSuccessSentences = [
  "Your JSON is as flawless as a moonless night.",
  "The structure holds, a testament to your dark craft.",
  "Valid JSON echoes in the chambers of my heart.",
  "A perfectly formatted payload, a dark symphony.",
  "The code is clean, the shadows approve.",
  "Your syntax is a dark, elegant poem.",
  "Success whispers on the wind, your JSON is true.",
  "The abyss yields, your formatting is impeccable.",
  "In the realm of data, your order prevails.",
  "A dark victory, your JSON is valid.",
  "The spirits nod, your brackets are balanced.",
  "Your formatting shines, a dark star in the void.",
  "The JSON is beautiful, a gothic masterpiece.",
  "Order from chaos, your formatting is a dark art.",
  "The night is pleased, your JSON is correct.",
  "A chilling success, your data is aligned.",
  "Your code is a dark, perfect mirror.",
  "The shadows rejoice, your JSON is valid.",
  "A haunting beauty, your formatting is complete.",
  "In the silence, your valid JSON speaks volumes.",
  // Add more goth success sentences related to JSON formatting here to reach 100
];

export const gothFailureSentences = [
  "Your JSON is as broken as my trust in humanity.",
  "A syntax error, a tear in the fabric of reality.",
  "Malformed data, a scream in the digital void.",
  "The structure crumbles, like my hopes and dreams.",
  "An unexpected token, a ghost in the machine.",
  "Your brackets weep, unbalanced and lost.",
  "Failure echoes in the dark, your JSON is flawed.",
  "The abyss consumes your invalid data.",
  "In the realm of data, chaos reigns.",
  "A dark defeat, your JSON is invalid.",
  "The spirits frown, your commas are misplaced.",
  "Your formatting is a dark, twisted mess.",
  "The JSON is hideous, a gothic nightmare.",
  "Chaos from order, your formatting is a dark curse.",
  "The night weeps, your JSON is incorrect.",
  "A chilling failure, your data is misaligned.",
  "Your code is a dark, broken reflection.",
  "The shadows despair, your JSON is invalid.",
  "A haunting failure, your formatting is incomplete.",
  "In the silence, your invalid JSON screams.",
  // Add more goth failure sentences related to JSON formatting here to reach 100
];
